/**
 * Formats a decimal value as a percentage string
 * @param value - The decimal value (e.g., 0.5 for 50%, 1.0 for 100%)
 * @param decimals - Number of decimal places to show (default: 0)
 * @returns Formatted percentage string (e.g., "50%", "100%")
 */
export const formatPercentage = (value: number, decimals: number = 0): string => {
  const percentage = value * 100;
  return `${percentage.toFixed(decimals)}%`;
};
